<template>
  <ModalComponent v-bind="$attrs" ref="modal" clickaway v-on="$listeners" class="remove">
    <Card tag="form" theme="flat" @submit.prevent="submit">
      <template #header>
        <FontAwesomeIcon :icon="['fal', 'exclamation-triangle']" size="2x" />
        <span class="remove__action-label mt-1">
          {{ overrideTitle ? overrideTitle : $t('youAreAboutToRemove') }}:
        </span>
        <strong class="remove__action-title" v-html="resource ? `${resource} (${title})` : title"></strong>
      </template>
      <template #default>
        <slot></slot>
      </template>
      <template #footer>
        <ButtonComponent
          :label="$t('confirm')"
          theme="primary"
          :icon="['fal', 'check']"
          :promise="promise"
          @onSuccess="$emit('onSuccess') && close()"
          type="submit"
        />
        <ButtonComponent :label="$t('cancel')" @click="close" />
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
import Card from '@/components/Card'
import { ModalComponent } from 'vue-elder-modal'
export default {
  props: {
    title: [String, Number],
    resource: String,
    action: Function,
    overrideTitle: String,
  },
  data() {
    return {
      promise: null,
    }
  },
  methods: {
    submit() {
      this.promise = this.action()
    },
    close() {
      if (!this.$refs.modal) return
      return this.$refs.modal.close()
    },
  },
  components: {
    ModalComponent,
    Card,
  },
}
</script>

<style lang="scss">
.remove {
  &__action {
    &-label {
      opacity: 0.8;
      margin-bottom: 3px;
    }

    &-title {
      font-size: 1.2em;
    }
  }

  & > .card > .card__header {
    background-color: css-alpha('error', 0.07);
    color: var(--error);

    & + .card__footer {
      background-color: white;
      border-top: none;
    }
  }

  .card__footer {
    & > div.row {
      justify-content: center;
    }
  }
}
</style>
